import { useDeviceType } from "@dash/mq";
import { useTheme } from "@emotion/react";

import { SignalDocumentGroup } from "./groupSignals";
import { signalDisplayLabel } from "./signalDisplayLabel";
import { isSignalTypeUnread, uniqueSignalsByType } from "./uniqueSignalsByType";

type Props = {
  group: SignalDocumentGroup;
  color: string;
  readOpacity: number;
};

const SignalLabelSeparator: React.FC = () => {
  const theme = useTheme();

  return (
    <span
      aria-hidden
      css={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "0.5rem",
        height: "1em",
        margin: "0 0.1875rem",
        flexShrink: 0,
        verticalAlign: "middle",
      }}
    >
      <span
        css={{
          width: "4px",
          height: "4px",
          borderRadius: "50%",
          background: theme.colors.secondaryText,
          opacity: 0.55,
        }}
      />
    </span>
  );
};

export const SignalLabelsList: React.FC<Props> = ({ group, color, readOpacity }) => {
  const { isMobile } = useDeviceType();
  const displaySignals = uniqueSignalsByType(group.signals);

  return (
  <span
    css={{
      fontSize: "0.875rem",
      color,
      overflow: isMobile ? "visible" : "hidden",
      textOverflow: isMobile ? undefined : "ellipsis",
      whiteSpace: isMobile ? "normal" : "nowrap",
      wordBreak: isMobile ? "break-word" : undefined,
    }}
  >
    {displaySignals.map((signal, index) => (
      <span key={signal.signalType}>
        {index > 0 && <SignalLabelSeparator />}
        <span css={{ opacity: isSignalTypeUnread(group.signals, signal.signalType) ? 1 : readOpacity }}>
          {signalDisplayLabel(signal)}
        </span>
      </span>
    ))}
  </span>
  );
};
